<template>
  <hypto-popup title="Beneficiary Bank Details" :footer="false">
    <template #body>
      <div class="status" v-if="details.end_time">
        <p>
          <i class="fa fa-check-circle" />
          Resolved
        </p>
      </div>

      <div v-for="(data, index) in events" :key="index" class="status-rows">
        <h6>{{data.field}}</h6>:
        <p :class="data.css">{{data.value}}</p>
      </div>

      <h5>Duration</h5>
      <div v-for="(data, index) in timings" :key="'duration_' + index" class="status-rows">
        <h6>{{data.field}}</h6>:
        <p>{{data.value}}</p>
      </div>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'
import moment from 'moment'

export default {
  name: 'BeneDetails',
  components: { HyptoPopup },
  props: {
    details: Object
  },
  data () {
    return {
      timings: [],
      events: [],
      dateFormat: 'DD-MMM-YYYY, hh:mm a'
    }
  },
  created () {
    this.populateData()
  },
  methods: {
    populateData () {
      this.addDetails('Payment Mode', this.details.pymt_type)
      this.addDetails('Bank', this.details.text)
      this.addDetails('Status', this.details.status)
      this.addTimings('Start Time', this.details.start_time)
      this.addTimings('End Time', this.details.end_time)
    },
    addDetails (field, value) {
      this.events.push({
        field, value
      })
    },
    addTimings (field, value) {
      value = this.timeFormat(value)
      this.timings.push({
        field, value
      })
    },
    timeFormat (time) {
      return time ? moment(time).format(this.dateFormat) : '-'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/rowDetails.scss';

  .status {
    border-radius: 5px;
    border: 1px solid $grey-outline;
    padding: 8px;
    margin-bottom: 10px;

    i {
      margin-right: 10px;
    }
  }

  .status-rows {
    display: flex;
    flex-wrap: wrap;
    margin: 5px 0;

    i {
      @include normal-text($grey-light, 13px, 400);
      width: 100%;
      text-align: left;
    }

    h6 {
      @include normal-text($grey-text, 13px, 500);
      width: 35%;
      margin-right: 10px;
      text-align: left
    }
    p {
      @include highlight-text($secondary, 13px);
      flex: 1;
      margin-left: 10px;
      text-align: left;
    }
  }

  h5 {
    padding: 4px 0;
    text-align: left;
    border-bottom: 1px solid $grey-outline;
    margin: 10px 0;
    font-weight: 400;
    font-size: 14px;
  }
</style>
